export default [
  {
    path: '/pengajuan-yudisium/baru',
    name: 'pengajuan-yudisium',
    component: () => import('@/views/pages/pengajuan-yudisium/FormWizard.vue'),
    meta: {
      resource: 'yudisium',
      action: 'create',
    },
  },
  {
    path: '/pengajuan-yudisium/edit/:uuid',
    name: 'pengajuan-yudisium-edit',
    component: () => import('@/views/pages/pengajuan-yudisium-edit/FormWizard.vue'),
    meta: {
      resource: 'yudisium',
      action: 'update',
    },
  },
  {
    path: '/pengajuan-yudisium/readonly/:uuid',
    name: 'pengajuan-yudisium-readonly',
    component: () => import('@/views/pages/pengajuan-yudisium-readonly/FormWizard.vue'),
    meta: {
      resource: 'yudisium',
      action: 'update',
    },
  },
  {
    path: '/pengajuan-sidang/baru',
    name: 'pengajuan-sidang-baru',
    component: () => import('@/views/pages/pengajuan-sidang-baru/FormWizard.vue'),
    meta: {
      resource: 'pengajuan-sidang',
      action: 'create',
    },
  },
  {
    path: '/pengajuan-sidang/edit/:uuid',
    name: 'pengajuan-sidang-edit',
    component: () => import('@/views/pages/pengajuan-sidang/FormWizard.vue'),
    meta: {
      resource: 'pengajuan-sidang',
      action: 'edit',
    },
  },
  {
    path: '/pengajuan-sidang/readonly/:uuid',
    name: 'pengajuan-sidang-readonly',
    component: () => import('@/views/pages/pengajuan-sidang-readonly/FormWizard.vue'),
    meta: {
      resource: 'pengajuan-sidang',
      action: 'readonly',
    },
  },
  {
    path: '/pengajuan-sidang/readonly/admin/:uuid',
    name: 'pengajuan-sidang-readonly-admin',
    component: () => import('@/views/pages/pengajuan-sidang-readonly-admin/FormWizard.vue'),
    meta: {
      resource: 'pengajuan-sidang',
      action: 'readonly',
    },
  },
  {
    path: '/rekapitulasi-pengajuan-sidang',
    name: 'rekapitulasi-pengajuan-sidang',
    component: () => import('@/views/pages/rekapitulasi-pengajuan-sidang/list/List.vue'),
    meta: {
      resource: 'rekapitulasi-pengajuan-sidang',
      action: 'read',
    },
  },
  {
    path: '/rekapitulasi-payroll',
    name: 'rekapitulasi-payroll',
    component: () => import('@/views/pages/rekapitulasi-payroll/list/List.vue'),
    meta: {
      resource: 'rekapitulasi-payroll',
      action: 'read',
    },
  },
  {
    path: '/rekapitulasi-jadwal-sidang',
    name: 'rekapitulasi-jadwal-sidang',
    component: () => import('@/views/pages/rekapitulasi-jadwal-sidang/list/List.vue'),
    meta: {
      resource: 'rekapitulasi-jadwal-sidang',
      action: 'read',
    },
  },
  {
    path: '/daftar-sidang',
    name: 'list-sidang',
    component: () => import('@/views/pages/daftar-sidang/list/List.vue'),
    meta: {
      resource: 'daftar-list-sidang',
      action: 'read',
    },
  },
  {
    path: '/jadwal-sidang',
    name: 'jadwal-sidang',
    component: () => import('@/views/pages/jadwal-sidang/list/List.vue'),
    meta: {
      resource: 'jadwal-sidang',
      action: 'read',
    },
  },
  {
    path: '/jadwal-sidang/:uuid',
    name: 'jadwal-sidang-edit',
    component: () => import('@/views/pages/jadwal-sidang/edit/Edit.vue'),
    meta: {
      resource: 'jadwal-sidang',
      action: 'manage',
    },
  },
  {
    path: '/surat-tugas',
    name: 'surat-tugas',
    component: () => import('@/views/pages/surat-tugas/list/List.vue'),
    meta: {
      resource: 'surat-tugas',
      action: 'read',
    },
  },
  {
    path: '/nota-dinas',
    name: 'nota-dinas',
    component: () => import('@/views/pages/nota-dinas/list/List.vue'),
    meta: {
      resource: 'nota-dinas',
      action: 'read',
    },
  },
  {
    path: '/setup-surat-tugas',
    name: 'setup-surat-tugas',
    component: () => import('@/views/pages/setup-surat-tugas/SetupSuratTugas.vue'),
    meta: {
      resource: 'setup-surat-tugas',
      action: 'read',
    },
  },
  {
    path: '/surat-tugas-pembimbing',
    name: 'surat-tugas-pembimbing',
    component: () => import('@/views/pages/surat-tugas-pembimbing/list/List.vue'),
    meta: {
      resource: 'surat-tugas-pembimbing',
      action: 'read',
    },
  },
  {
    path: '/sktmt',
    name: 'sktmt',
    component: () => import('@/views/pages/sktmt/list/List.vue'),
    meta: {
      resource: 'sktmt',
      action: 'read',
    },
  },
  {
    path: '/notifikasi-email',
    name: 'notifikasi-email',
    component: () => import('@/views/pages/notifikasi-email/list/List.vue'),
    meta: {
      resource: 'notifikasi-email',
      action: 'read',
    },
  },
  {
    path: '/notifikasi-email/:uuid',
    name: 'notifikasi-email-edit',
    component: () => import('@/views/pages/notifikasi-email/edit/Edit.vue'),
    meta: {
      resource: 'all',
      action: 'manage',
    },
  },
  {
    path: '/hasil-sidang',
    name: 'hasil-sidang',
    component: () => import('@/views/pages/hasil-sidang/list/List.vue'),
    meta: {
      resource: 'hasil-sidang',
      action: 'read',
    },
  },
  {
    path: '/hasil-sidang-edit/:uuid',
    name: 'hasil-sidang-edit',
    component: () => import('@/views/pages/hasil-sidang/tab/Tab.vue'),
    meta: {
      resource: 'hasil-sidang',
      action: 'edit',
    },
  },
  {
    path: '/hasil-sidang-edit/perubahan-nilai/:uuid',
    name: 'hasil-sidang-perubahan-nilai-edit',
    component: () => import('@/views/pages/hasil-sidang/perubahan-nilai/Tab.vue'),
    meta: {
      resource: 'hasil-sidang',
      action: 'edit-perubahan-nilai',
    },
  },
  {
    path: '/pengguna',
    name: 'pengguna',
    component: () => import('@/views/pages/pengguna/list/List.vue'),
    meta: {
      resource: 'pengguna',
      action: 'read',
    },
  },
  {
    path: '/pengguna-daftar-baru',
    name: 'pengguna-daftar-baru',
    component: () => import('@/views/pages/pengguna-daftar-baru/list/List.vue'),
    meta: {
      resource: 'pengguna',
      action: 'read',
    },
  },
  {
    path: '/pengguna-edit/:id',
    name: 'pengguna-edit',
    component: () => import('@/views/pages/account-setting/AccountSetting.vue'),
    meta: {
      resource: 'pengguna',
      action: 'read',
    },
  },
  {
    path: '/hak-akses',
    name: 'hak-akses',
    component: () => import('@/views/pages/rules/list/List.vue'),
    meta: {
      resource: 'hak-akses',
      action: 'read',
    },
  },
  {
    path: '/hak-akses/edit/:id',
    name: 'hak-akses-edit',
    component: () => import('@/views/pages/rules/edit/Edit.vue'),
    meta: {
      resource: 'hak-akses',
      action: 'edit',
    },
  },
  {
    path: '/dosen',
    name: 'dosen',
    component: () => import('@/views/pages/dosen/list/List.vue'),
    meta: {
      resource: 'dosen',
      action: 'read',
    },
  },
  {
    path: '/dosen/:uuid',
    name: 'dosen-edit',
    component: () => import('@/views/pages/dosen/edit/Edit.vue'),
    meta: {
      resource: 'dosen',
      action: 'read',
    },
  },
  {
    path: '/jenjang',
    name: 'jenjang',
    component: () => import('@/views/pages/jenjang/list/List.vue'),
    meta: {
      resource: 'jenjang',
      action: 'read',
    },
  },
  {
    path: '/jenjang/:uuid',
    name: 'jenjang-edit',
    component: () => import('@/views/pages/jenjang/edit/Edit.vue'),
    meta: {
      resource: 'jenjang',
      action: 'read',
    },
  },
  {
    path: '/prodi',
    name: 'prodi',
    component: () => import('@/views/pages/prodi/list/List.vue'),
    meta: {
      resource: 'prodi',
      action: 'read',
    },
  },
  {
    path: '/prodi/:uuid',
    name: 'prodi-edit',
    component: () => import('@/views/pages/prodi/edit/Edit.vue'),
    meta: {
      resource: 'prodi',
      action: 'read',
    },
  },
  {
    path: '/peminatan',
    name: 'peminatan',
    component: () => import('@/views/pages/peminatan/list/List.vue'),
    meta: {
      resource: 'peminatan',
      action: 'read',
    },
  },
  {
    path: '/peminatan/:uuid',
    name: 'peminatan-edit',
    component: () => import('@/views/pages/peminatan/edit/Edit.vue'),
    meta: {
      resource: 'peminatan',
      action: 'read',
    },
  },
  {
    path: '/program',
    name: 'program',
    component: () => import('@/views/pages/program/list/List.vue'),
    meta: {
      resource: 'program',
      action: 'read',
    },
  },
  {
    path: '/program/:uuid',
    name: 'program-edit',
    component: () => import('@/views/pages/program/edit/Edit.vue'),
    meta: {
      resource: 'program',
      action: 'read',
    },
  },
  {
    path: '/ruangan',
    name: 'ruangan',
    component: () => import('@/views/pages/ruangan/list/List.vue'),
    meta: {
      resource: 'ruangan',
      action: 'read',
    },
  },
  {
    path: '/ruangan/:uuid',
    name: 'ruangan-edit',
    component: () => import('@/views/pages/ruangan/edit/Edit.vue'),
    meta: {
      resource: 'ruangan',
      action: 'read',
    },
  },
  {
    path: '/jadwal-external-umum',
    name: 'jadwal-external-umum',
    component: () => import('@/views/pages/jadwal-external-umum/list/List.vue'),
    meta: {
      resource: 'ruangan',
      action: 'read',
    },
  },
  {
    path: '/jadwal-external-umum/:uuid',
    name: 'jadwal-external-umum-edit',
    component: () => import('@/views/pages/jadwal-external-umum/edit/Edit.vue'),
    meta: {
      resource: 'jadwal-external-umum',
      action: 'read',
    },
  },
  {
    path: '/waktu-ujian',
    name: 'waktu-ujian',
    component: () => import('@/views/pages/waktu-ujian/list/List.vue'),
    meta: {
      resource: 'waktu-ujian',
      action: 'read',
    },
  },
  {
    path: '/waktu-ujian/:uuid',
    name: 'waktu-ujian-edit',
    component: () => import('@/views/pages/waktu-ujian/edit/Edit.vue'),
    meta: {
      resource: 'waktu-ujian',
      action: 'read',
    },
  },
  {
    path: '/status-hasil-sidang',
    name: 'status-hasil-sidang',
    component: () => import('@/views/pages/status-hasil-sidang/list/List.vue'),
    meta: {
      resource: 'status-hasil-sidang',
      action: 'read',
    },
  },
  {
    path: '/status-hasil-sidang/:uuid',
    name: 'status-hasil-sidang-edit',
    component: () => import('@/views/pages/status-hasil-sidang/edit/Edit.vue'),
    meta: {
      resource: 'status-hasil-sidang',
      action: 'read',
    },
  },
  {
    path: '/status-jadwal-sidang',
    name: 'status-jadwal-sidang',
    component: () => import('@/views/pages/status-jadwal-sidang/list/List.vue'),
    meta: {
      resource: 'status-jadwal-sidang',
      action: 'read',
    },
  },
  {
    path: '/status-jadwal-sidang/:uuid',
    name: 'status-jadwal-sidang-edit',
    component: () => import('@/views/pages/status-jadwal-sidang/edit/Edit.vue'),
    meta: {
      resource: 'status-jadwal-sidang',
      action: 'read',
    },
  },
  {
    path: '/status-pengajuan-sidang',
    name: 'status-pengajuan-sidang',
    component: () => import('@/views/pages/status-pengajuan-sidang/list/List.vue'),
    meta: {
      resource: 'status-pengajuan-sidang',
      action: 'read',
    },
  },
  {
    path: '/status-pengajuan-sidang/:uuid',
    name: 'status-pengajuan-sidang-edit',
    component: () => import('@/views/pages/status-pengajuan-sidang/edit/Edit.vue'),
    meta: {
      resource: 'status-pengajuan-sidang',
      action: 'read',
    },
  },
  {
    path: '/proses-persidangan',
    name: 'proses-persidangan',
    component: () => import('@/views/pages/proses-persidangan/list/List.vue'),
    meta: {
      resource: 'proses-persidangan',
      action: 'read',
    },
  },
  {
    path: '/proses-persidangan/:uuid',
    name: 'proses-persidangan-edit',
    component: () => import('@/views/pages/proses-persidangan/edit/Edit.vue'),
    meta: {
      resource: 'proses-persidangan',
      action: 'read',
    },
  },
  {
    path: '/sync-dosen',
    name: 'sync-dosen',
    component: () => import('@/views/pages/sync-dosen/list/List.vue'),
    meta: {
      resource: 'sync-dosen',
      action: 'read',
    },
  },
  {
    path: '/periode-ujian',
    name: 'periode-ujian',
    component: () => import('@/views/pages/periode-ujian/list/List.vue'),
    meta: {
      resource: 'periode-ujian',
      action: 'read',
    },
  },
  {
    path: '/daftar-yudisium',
    name: 'daftar-yudisium',
    component: () => import('@/views/pages/daftar-yudisium/list/List.vue'),
    meta: {
      resource: 'yudisium',
      action: 'read',
    },
  },
  {
    path: '/account/reset/:token',
    name: 'reset-account',
    component: () => import('@/views/pages/reset-akun/edit/Edit.vue'),
    meta: {
      resource: 'pengajuan-sidang',
      action: 'readonly',
    },
  },

  // {
  //   path: '/apps/calendar',
  //   name: 'apps-calendar',
  //   component: () => import('@/views/apps/calendar/Calendar.vue'),
  // },

  // // *===============================================---*
  // // *--------- EMAIL & IT'S FILTERS N LABELS -------------------------------*
  // // *===============================================---*
  // {
  //   path: '/apps/email',
  //   name: 'apps-email',
  //   component: () => import('@/views/apps/email/Email.vue'),
  //   meta: {
  //     contentRenderer: 'sidebar-left',
  //     contentClass: 'email-application',
  //   },
  // },
  // {
  //   path: '/apps/email/:folder',
  //   name: 'apps-email-folder',
  //   component: () => import('@/views/apps/email/Email.vue'),
  //   meta: {
  //     contentRenderer: 'sidebar-left',
  //     contentClass: 'email-application',
  //     navActiveLink: 'apps-email',
  //   },
  //   beforeEnter(to, _, next) {
  //     if (['sent', 'draft', 'starred', 'spam', 'trash'].includes(to.params.folder)) next()
  //     else next({ name: 'error-404' })
  //   },
  // },
  // {
  //   path: '/apps/email/label/:label',
  //   name: 'apps-email-label',
  //   component: () => import('@/views/apps/email/Email.vue'),
  //   meta: {
  //     contentRenderer: 'sidebar-left',
  //     contentClass: 'email-application',
  //     navActiveLink: 'apps-email',
  //   },
  //   beforeEnter(to, _, next) {
  //     if (['personal', 'company', 'important', 'private'].includes(to.params.label)) next()
  //     else next({ name: 'error-404' })
  //   },
  // },

  // // *===============================================---*
  // // *--------- TODO & IT'S FILTERS N TAGS ---------------------------------------*
  // // *===============================================---*
  // {
  //   path: '/apps/todo',
  //   name: 'apps-todo',
  //   component: () => import('@/views/apps/todo/Todo.vue'),
  //   meta: {
  //     contentRenderer: 'sidebar-left',
  //     contentClass: 'todo-application',
  //   },
  // },
  // {
  //   path: '/apps/todo/:filter',
  //   name: 'apps-todo-filter',
  //   component: () => import('@/views/apps/todo/Todo.vue'),
  //   meta: {
  //     contentRenderer: 'sidebar-left',
  //     contentClass: 'todo-application',
  //     navActiveLink: 'apps-todo',
  //   },
  //   beforeEnter(to, _, next) {
  //     if (['important', 'completed', 'deleted'].includes(to.params.filter)) next()
  //     else next({ name: 'error-404' })
  //   },
  // },
  // {
  //   path: '/apps/todo/tag/:tag',
  //   name: 'apps-todo-tag',
  //   component: () => import('@/views/apps/todo/Todo.vue'),
  //   meta: {
  //     contentRenderer: 'sidebar-left',
  //     contentClass: 'todo-application',
  //     navActiveLink: 'apps-todo',
  //   },
  //   beforeEnter(to, _, next) {
  //     if (['team', 'low', 'medium', 'high', 'update'].includes(to.params.tag)) next()
  //     else next({ name: 'error-404' })
  //   },
  // },

  // // *===============================================---*
  // // *--------- CHAT  ---------------------------------------*
  // // *===============================================---*
  // {
  //   path: '/apps/chat',
  //   name: 'apps-chat',
  //   component: () => import('@/views/apps/chat/Chat.vue'),
  //   meta: {
  //     contentRenderer: 'sidebar-left',
  //     contentClass: 'chat-application',
  //   },
  // },

  // // *===============================================---*
  // // *--------- ECOMMERCE  ---------------------------------------*
  // // *===============================================---*
  // {
  //   path: '/apps/e-commerce/shop',
  //   name: 'apps-e-commerce-shop',
  //   component: () => import('@/views/apps/e-commerce/e-commerce-shop/ECommerceShop.vue'),
  //   meta: {
  //     contentRenderer: 'sidebar-left-detached',
  //     contentClass: 'ecommerce-application',
  //     pageTitle: 'Shop',
  //     breadcrumb: [
  //       {
  //         text: 'ECommerce',
  //       },
  //       {
  //         text: 'Shop',
  //         active: true,
  //       },
  //     ],
  //   },
  // },
  // {
  //   path: '/apps/e-commerce/wishlist',
  //   name: 'apps-e-commerce-wishlist',
  //   component: () => import('@/views/apps/e-commerce/e-commerce-wishlist/ECommerceWishlist.vue'),
  //   meta: {
  //     pageTitle: 'Wishlist',
  //     contentClass: 'ecommerce-application',
  //     breadcrumb: [
  //       {
  //         text: 'ECommerce',
  //       },
  //       {
  //         text: 'Wishlist',
  //         active: true,
  //       },
  //     ],
  //   },
  // },
  // {
  //   path: '/apps/e-commerce/checkout',
  //   name: 'apps-e-commerce-checkout',
  //   component: () => import('@/views/apps/e-commerce/e-commerce-checkout/ECommerceCheckout.vue'),
  //   meta: {
  //     pageTitle: 'Checkout',
  //     contentClass: 'ecommerce-application',
  //     breadcrumb: [
  //       {
  //         text: 'ECommerce',
  //       },
  //       {
  //         text: 'Checkout',
  //         active: true,
  //       },
  //     ],
  //   },
  // },
  // {
  //   path: '/apps/e-commerce/:slug',
  //   name: 'apps-e-commerce-product-details',
  //   component: () => import('@/views/apps/e-commerce/e-commerce-product-details/ECommerceProductDetails.vue'),
  //   meta: {
  //     pageTitle: 'Product Details',
  //     contentClass: 'ecommerce-application',
  //     breadcrumb: [
  //       {
  //         text: 'ECommerce',
  //       },
  //       {
  //         text: 'Shop',
  //         active: true,
  //       },
  //       {
  //         text: 'Product Details',
  //         active: true,
  //       },
  //     ],
  //   },
  // },

  // // *===============================================---*
  // // *--------- USER ---- ---------------------------------------*
  // // *===============================================---*
  // {
  //   path: '/apps/users/list',
  //   name: 'apps-users-list',
  //   component: () => import('@/views/apps/user/users-list/UsersList.vue'),
  // },
  // {
  //   path: '/apps/users/view/:id',
  //   name: 'apps-users-view',
  //   component: () => import('@/views/apps/user/users-view/UsersView.vue'),
  // },
  // {
  //   path: '/apps/users/edit/:id',
  //   name: 'apps-users-edit',
  //   component: () => import('@/views/apps/user/users-edit/UsersEdit.vue'),
  // },

  // // Invoice
  // {
  //   path: '/apps/invoice/list',
  //   name: 'apps-invoice-list',
  //   component: () => import('@/views/apps/invoice/invoice-list/InvoiceList.vue'),
  // },
  // {
  //   path: '/apps/invoice/preview/:id',
  //   name: 'apps-invoice-preview',
  //   component: () => import('@/views/apps/invoice/invoice-preview/InvoicePreview.vue'),
  // },
  // {
  //   path: '/apps/invoice/add/',
  //   name: 'apps-invoice-add',
  //   component: () => import('@/views/apps/invoice/invoice-add/InvoiceAdd.vue'),
  // },
  // {
  //   path: '/apps/invoice/edit/:id',
  //   name: 'apps-invoice-edit',
  //   component: () => import('@/views/apps/invoice/invoice-edit/InvoiceEdit.vue'),
  // },
]
